module.exports = __webpack_public_path__ + "static/media/zaloguj.6f96ff22.jpg";